import type { Dict } from "../lib/i18n";

// Public landing page shown to visitors who are not signed in. Keys prefixed "landing.".
export default {
  zh: {
    "landing.plusLine": "家庭账本、拍小票记账、饮食（热量和糖）、食材库、物品库和 AI 估算属于 Plus：€89/年（推荐，创始会员 €69/年）或 €9.99/月。",
    "landing.login": "登录",
    "landing.signup": "免费注册，开始使用",
    "landing.haveAccount": "我已有账号，登录",
    "landing.eyebrow": "家庭生活好帮手",
    "landing.title": "买菜、记账、吃得健康，一个 App 就够了",
    "landing.sub": "清单、记账、饮食和食材库连在一起，全家一个 App 管好。",
    "landing.featuresTitle": "它能帮你做什么",
    "landing.lead": "列购物清单、收好会员卡、拍小票自动记账、拍一下就能估算每餐的卡路里和碳水摄入。专为忙碌的家庭设计，手机上用起来像原生 App 一样顺手。",
    "landing.note": "全部功能免费试用 14 天，不需要绑卡 · 支持 11 种语言",
    "landing.freeTitle": "注册后永久免费，不用订阅",
    "landing.free1": "购物清单",
    "landing.free2": "会员卡包",
    "landing.free3": "附近商家",
    "landing.ctaTitle": "今天就开始，让家里的账更清楚",
    "landing.ask.title": "关于 NutriCart，想问什么都可以",
    "landing.ask.note": "AI 助手回答，可能出错。请不要输入个人信息。",
    "landing.ask.q1": "它能帮我做什么？",
    "landing.ask.q2": "免费吗？",
    "landing.ask.q3": "我的数据安全吗？",
    "landing.ask.placeholder": "写下你的问题……",
    "landing.ask.thinking": "正在回答…",
    "landing.ask.failed": "AI 助手暂时不可用，请稍后再试，或者直接免费注册试用。",
    "landing.footer": "NutriCart · 家庭开支与健康生活",
    "landing.preview": "App 首页预览",
  },
  en: {
    "landing.plusLine": "The household budget, receipt scanning, calories & sugar, the pantry, home goods and AI estimates are part of Plus: €89/year (best value; founding members €69/year) or €9.99/month.",
    "landing.login": "Sign in",
    "landing.signup": "Sign up free",
    "landing.haveAccount": "I have an account, sign in",
    "landing.eyebrow": "Your household helper",
    "landing.title": "Shopping, spending and eating well, in one app",
    "landing.sub": "List, budget, meals and pantry, all connected: one app for the whole family.",
    "landing.featuresTitle": "What it does for you",
    "landing.lead": "Make shopping lists, keep your loyalty cards handy, snap receipts into a budget and snap a photo to estimate the calories and carbs of each meal. Made for busy households and smooth on your phone.",
    "landing.note": "Try every feature free for 14 days, no card needed · 11 languages",
    "landing.freeTitle": "Free forever once you sign up, no subscription",
    "landing.free1": "Shopping list",
    "landing.free2": "Loyalty cards",
    "landing.free3": "Shops nearby",
    "landing.ctaTitle": "Start today and see your household money clearly",
    "landing.ask.title": "Ask anything about NutriCart",
    "landing.ask.note": "Answered by an AI helper, which can make mistakes. Please don't enter personal details.",
    "landing.ask.q1": "What can it do for me?",
    "landing.ask.q2": "Is it free?",
    "landing.ask.q3": "Is my data safe?",
    "landing.ask.placeholder": "Type your question…",
    "landing.ask.thinking": "Answering…",
    "landing.ask.failed": "The AI helper isn't available right now. Try again later, or just sign up free and try the app.",
    "landing.footer": "NutriCart · household spending & wellbeing",
    "landing.preview": "Preview of the app's home screen",
  },
  nl: {
    "landing.plusLine": "Het huishoudboekje, bonnetjes scannen, calorieën & suiker, de voorraad, spullen in huis en AI-schattingen horen bij Plus: €89/jaar (voordeligst; oprichters €69/jaar) of €9,99/maand.",
    "landing.login": "Inloggen",
    "landing.signup": "Gratis aanmelden",
    "landing.haveAccount": "Ik heb al een account, inloggen",
    "landing.eyebrow": "Je hulp in het huishouden",
    "landing.title": "Boodschappen, uitgaven en gezond eten in één app",
    "landing.sub": "Lijst, huishoudboekje, maaltijden en voorraad, allemaal verbonden: één app voor het hele gezin.",
    "landing.featuresTitle": "Wat het voor je doet",
    "landing.lead": "Maak boodschappenlijstjes, heb je klantenkaarten altijd bij de hand, zet bonnetjes met een foto in je huishoudboekje en maak een foto om de calorieën en koolhydraten van elke maaltijd te schatten. Gemaakt voor drukke huishoudens en prettig op je telefoon.",
    "landing.note": "Probeer alle functies 14 dagen gratis, zonder betaalgegevens · 11 talen",
    "landing.freeTitle": "Na aanmelden altijd gratis, geen abonnement nodig",
    "landing.free1": "Boodschappenlijst",
    "landing.free2": "Klantenkaarten",
    "landing.free3": "Winkels in de buurt",
    "landing.ctaTitle": "Begin vandaag en krijg overzicht over je huishoudgeld",
    "landing.ask.title": "Vraag alles over NutriCart",
    "landing.ask.note": "Beantwoord door een AI-helper, die fouten kan maken. Vul geen persoonlijke gegevens in.",
    "landing.ask.q1": "Wat kan de app voor mij doen?",
    "landing.ask.q2": "Is het gratis?",
    "landing.ask.q3": "Zijn mijn gegevens veilig?",
    "landing.ask.placeholder": "Typ je vraag…",
    "landing.ask.thinking": "Even denken…",
    "landing.ask.failed": "De AI-helper is nu niet beschikbaar. Probeer het later opnieuw, of meld je gratis aan en probeer de app.",
    "landing.footer": "NutriCart · huishouden & gezond leven",
    "landing.preview": "Voorbeeld van het startscherm van de app",
  },
} satisfies Dict;
